import { useTranslation } from 'react-i18next'
import { FC } from 'react'

export const TransactionExplanation: FC<{ texts: string[] }> = ({ texts }) => {
  const { t } = useTranslation()

  return (
    <div className="text-secondary-color text-xs">
      {texts.map(text => (
        <p key={text} className="mb-2 last:mb-0">
          <span className="text-main-color">* </span>
          {t(text)}
        </p>
      ))}
    </div>
  )
}

export const TransactionInCreditExplanation = () => (
  <TransactionExplanation
    texts={['transactionInCreditExplanation.1', 'transactionInCreditExplanation.2']}
  />
)

export const SomeTransactionInCreditExplanation = () => (
  <TransactionExplanation texts={['transactionInCreditExplanation.3']} />
)

export const TransactionWithPaymentProviderExplanation = () => (
  <TransactionExplanation
    texts={[
      'transactionWithPaymentProviderExplanation.1',
      'transactionWithPaymentProviderExplanation.2',
    ]}
  />
)
